module.exports = __webpack_public_path__ + "img/bg-lover-square.29a4b174.webp";